import type { DirectiveBinding } from 'vue'

const observers: WeakMap<Element, IntersectionObserver> = new WeakMap()

/**
 * Directive `v-reveal` : ajoute la classe `is-in-view` à la première entrée de l'élément dans le viewport (un observer par élément → apparition au scroll, carte par carte). La valeur passée (nombre, en ms) applique un délai de transition pour un effet staggeré.
 */
export default defineNuxtPlugin((nuxtApp): void => {
  nuxtApp.vueApp.directive('reveal', {
    mounted(el: HTMLElement, binding: DirectiveBinding<number | undefined>): void {
      const delay: number = typeof binding.value === 'number' ? binding.value : 0
      el.style.transitionDelay = `${delay}ms`
      const observer: IntersectionObserver = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]): void => {
          if (entries[0]?.isIntersecting === true) {
            el.classList.add('is-in-view')
            observer.disconnect()
          }
        },
        { threshold: 0.25 },
      )
      observer.observe(el)
      observers.set(el, observer)
    },
    unmounted(el: HTMLElement): void {
      observers.get(el)?.disconnect()
      observers.delete(el)
    },
  })
})
